"use strict";
var ApiQuoteTripResponse = (function () {
    function ApiQuoteTripResponse() {
    }
    return ApiQuoteTripResponse;
}());
exports.ApiQuoteTripResponse = ApiQuoteTripResponse;
//# sourceMappingURL=D:/a/1/s/purchase/src/models/api-quote-trip-response.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/models/api-quote-trip-response.model.js